import { BaseDto } from '@/core';

export class EditedMessageDto extends BaseDto<EditedMessageDto> {
  message: string;
}
